import { render, staticRenderFns } from "./ServiceRouteOrganizer.vue?vue&type=template&id=fddb0398&scoped=true"
import script from "./ServiceRouteOrganizer.vue?vue&type=script&lang=js"
export * from "./ServiceRouteOrganizer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fddb0398",
  null
  
)

export default component.exports